/* eslint-disable */


/**
 * Create styles for `<Notification />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Notification />` styles
 */
const notificationStyles = ({ theme }) => ({
  icon: {
    height: theme.spacing(1) * 3,
    marginRight: theme.spacing(1) * 2,
    opacity: 0.25,
    width: theme.spacing(1) * 3,
  },
  message: {
    marginBottom: theme.spacing(1),
  },
  notification: {
    padding: Math.round(theme.spacing(1) * 2.3),
  },
  unread: {
    backgroundColor: theme.palette.grey[100],
  },
});

export default notificationStyles;
